// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2odGI","header":"ReportDetails_header__2GSYV","title":"ReportDetails_title__J9Q2-","left":"ReportDetails_left__uAMI7"};